export const config = {
  localStorage: {
    language: "language",
    theme: "theme",
  },
  default: {
    language: "nl_NL",
    theme: "dark",
  },
  isUnderConstruction: false,
};

// Returns the title for HTML
export const createTitle = (title: string) => {
  return `${title} - Next Generation`;
};
